import ListView from "../../../components/listView/ListView";
import Page from "../../../components/pageView/Page";
import WarehouseLayoutPage from "../../../pages/apps/warehouse/WarehouseLayoutPage";
import WarehouseSitePage from "../../../pages/apps/warehouse/WarehouseSitePage";
import WidgetPage from "../../../components/widgetPage/WidgetPage";

const routesWarehouse = [
    {
        path: "/warehouse",
        element: WidgetPage,
        props: {
            type: "warehouse",
            draggable: false,
            resizable: false,
        }
    },
    {
        path: "/warehouse/warehouseOrder",
        element: ListView,
        props: {
            type: "warehouseOrderList",
        }
    },
    {
        path: "/warehouse/warehouseOrder/new",
        element: Page,
        props: {
            type: "warehouseOrderNewPage",
            options: { mode: "new", load: false },
        }
    },
    {
        path: "/warehouse/warehouseOrder/pick/:id",
        element: Page,
        props: {
            type: "warehousePickPage",
            options: { mode: "edit", load: true },
        }
    },
    {
        path: "/warehouse/warehouseOrder/putaway/:id",
        element: Page,
        props: {
            type: "warehousePutawayPage",
            options: { mode: "edit", load: true },
        }
    },
    {
        path: "/warehouse/warehouseOrder/transfer/:id",
        element: Page,
        props: {
            type: "warehouseTransferPage",
            options: { mode: "edit", load: true },
        }
    },
    {
        path: "/warehouse/warehouseOrder/quarantine/:id",
        element: Page,
        props: {
            type: "warehouseQuarantinePage",
            options: { mode: "edit", load: true },
        }
    },
    {
        path: "/warehouse/warehouseOrder/return/:id",
        element: Page,
        props: {
            type: "warehouseReturnPage",
            options: { mode: "edit", load: true },
        }
    },
    {
        path: "/warehouse/layout",
        element: WarehouseLayoutPage,
        props: {}
    },
    {
        path: "/warehouse/site",
        element: WarehouseSitePage,
        props: {}
    },
    {
        path: "/warehouse/layout/:warehouseId",
        element: WarehouseLayoutPage,
        props: {}
    },
    {
        path: "/warehouse/warehousePath",
        element: ListView,
        props: { type: "warehousePathList" }
    },
    {
        path: "/warehouse/warehousePath/:id",
        element: Page,
        props: { type: "warehousePathPage", options: { mode: "edit", load: true, onMount: 'collapse' } }
    },
    {
        path: "/warehouse/warehouseOrder/released",
        element: ListView,
        props: {
            type: "warehouseOrderReleasedList",
        }
    },
    {
        path: "/warehouse/warehouseOrder/:id",
        element: Page,
        props: {
            type: "warehouseOrderPage",
            options: { mode: "edit", load: true, onMount: 'collapse' },
        }
    },
];

export default routesWarehouse;
